import Team from '../components/Team';
import { Box } from '@mui/material';

const TeamPage = () => {
  return (
    <Box sx={{ pt: 8 }}>
      <Team />
    </Box>
  );
};

export default TeamPage;
